// @LTG-ID: F-076
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 02_DESIGN_SYSTEM.md (signature design devices), 08_FEATURES.md#F-076
// @CHANGED: 2026-02 session_001
// @OWNER: web
//
// Italic period — the explicit <em>.</em> device used at the end of h2 headings
// across the source bundle. Wrapped here so the pattern is self-documenting.

export const ItalicPeriod = ({ className = "", ...rest }) => (
    <em
        data-testid="italic-period"
        className={`ltg-italic-period ${className}`.trim()}
        style={{ fontStyle: "italic" }}
        {...rest}
    >
        .
    </em>
);

export default ItalicPeriod;
